import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_PORTFOLIO_DETAIL_FLEX_API =
  'INVESTMENT/FETCH_PORTFOLIO_DETAIL_FLEX_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_PORTFOLIO_DETAIL_FLEX_API,
  ({ userId }) => ({
    endpoint: `/api/admin/portfolios/flexs/${userId}`,
    method: 'GET',
  })
);

export default apiCall;
